import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useEffect, useMemo } from 'react';
import { ListContextProvider } from './list-context.esm.js';
import { LIST_THEME_KEY } from './types.esm.js';
import { noop } from '../../utils/function.esm.js';
import { createUseStyledComponent } from '../../hooks/use-styled-component.esm.js';
import useTimeout from '../../hooks/use-timeout.esm.js';

var _excluded = ["__variants", "__themeKey", "variant", "className", "children", "as", "dense", "disablePadding", "subheader", "onMounted"];
var useStyledComponent = createUseStyledComponent(['ul', 'ol'], 'csg-list');
var ListPrivate = /*#__PURE__*/React.forwardRef(function ListPrivate(props, ref) {
  var __variants = props.__variants,
    _props$__themeKey = props.__themeKey,
    __themeKey = _props$__themeKey === void 0 ? LIST_THEME_KEY : _props$__themeKey,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'list' : _props$variant,
    className = props.className,
    children = props.children,
    _props$as = props.as,
    component = _props$as === void 0 ? 'ul' : _props$as,
    _props$dense = props.dense,
    dense = _props$dense === void 0 ? false : _props$dense,
    _props$disablePadding = props.disablePadding,
    disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
    subheader = props.subheader,
    _props$onMounted = props.onMounted,
    onMounted = _props$onMounted === void 0 ? noop : _props$onMounted,
    rest = _objectWithoutProperties(props, _excluded);
  var Component = useStyledComponent(component, __variants);
  var delayExecute = useTimeout();
  useEffect(function () {
    return delayExecute(onMounted);
  }, [onMounted, delayExecute]);
  var baseStyles = useMemo(function () {
    return _objectSpread2(_objectSpread2({
      margin: 0,
      padding: 0,
      position: 'relative'
    }, !disablePadding ? {
      py: 'sm'
    } : {}), subheader ? {
      pt: 0
    } : {});
  }, [disablePadding, subheader]);
  return /*#__PURE__*/React.createElement(ListContextProvider, {
    dense: dense,
    variant: variant === 'list' ? undefined : variant
  }, /*#__PURE__*/React.createElement(Component, _extends({
    variant: __themeKey === LIST_THEME_KEY // independent list component i.e. not part of other compound component
    ? variant === 'list' ? 'list' : "".concat(variant, ".list") : variant,
    __themeKey: __themeKey,
    className: classNames({
      'csg-tui-list': true
    }, className),
    __css: baseStyles,
    ref: ref
  }, rest), subheader, typeof children === 'function' ? children() : children));
});
var MemoList = /*#__PURE__*/React.memo(ListPrivate);
var List = /*#__PURE__*/React.forwardRef(function List(props, ref) {
  return /*#__PURE__*/React.createElement(MemoList, _extends({
    ref: ref
  }, props));
});

export default List;
export { ListPrivate };
//# sourceMappingURL=list.esm.js.map
